import { useQuery } from "@tanstack/react-query";

import type { SupportTicketDetail } from "../../shared/support-schemas";
import { listSavedReplies, supportKeys } from "./support-api";
import { personalize, withSavedReply } from "./support-format";

/**
 * Inserts a saved reply into the reply box (ADR-0089). The person edits it there and still sends
 * the reply themselves.
 */
export function SupportSavedReplyPicker({
  ticket,
  body,
  disabled,
  onInsert,
}: {
  ticket: SupportTicketDetail;
  body: string;
  disabled: boolean;
  onInsert: (body: string) => void;
}) {
  const replies = useQuery({ queryKey: supportKeys.savedReplies(), queryFn: listSavedReplies });
  const available = replies.data?.replies ?? [];
  if (available.length === 0) return null;
  return (
    <label
      className="flex max-w-xs flex-col gap-1 text-sm font-medium"
      htmlFor="support-saved-reply"
    >
      Insert a saved reply
      <select
        id="support-saved-reply"
        className="h-10 w-full rounded-sm border border-input bg-card px-3 text-sm font-normal disabled:opacity-60"
        value=""
        disabled={disabled}
        onChange={(event) => {
          const chosen = available.find((reply) => reply.id === event.currentTarget.value);
          if (chosen) onInsert(withSavedReply(body, personalize(chosen.bodyText, ticket)));
        }}
      >
        <option value="">Choose one…</option>
        {available.map((reply) => (
          <option key={reply.id} value={reply.id}>
            {reply.title}
          </option>
        ))}
      </select>
    </label>
  );
}
